import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  Linking,
  Platform,
} from 'react-native';
import ImageTextCard from './childComponents/ImageTextCard';
import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {
  avatar,
  account_refer,
  account_support,
  account_profile,
  account_telegram,
  account_privacy,
  account_raiseTicket,
  back_arrow,
} from '../../utils/images';
import AccountRedirectionCard from './childComponents/AccountRedirectionCard';
import {Color, globalFontStyle, globalStyle} from '../../assets';
import CommonModal from '../../commonComponents/commonModal';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Colors from '../../assets/Color/Colors';
import Width from '../../assets/Width';
import {logout} from '../../utils/logOut';
import DeleteModal from './childComponents/LogoutModal';
import {getClubList} from '../clubs/redux/clubs.action';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {
  getLoginRoute,
  isMobile,
  loadScript,
  removeScript,
} from '../../utils/commonMethods';
import {globalImport} from '../../common/globalImports';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../utils/globalConstant';
import {useFocusEffect} from '@react-navigation/native';
import FastImage from '../../common/FastImage';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import {Button} from '../../components/core/Button';
import { useToast } from '../../components/core/Toast';

const Account = ({navigation, profileData, getClubList, clubList}) => {
  //const [logedIn, setLogedIn] = React.useState(null);
  const logedIn = useSelector(({utilReducer}) => utilReducer.isAppLogin);
  const insets = useSafeAreaInsets();
  const { toast } = useToast();

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const [noClubs, setNoClubs] = useState(true);
  const [showLogOut, setShowLogOut] = useState(false);

  // useFocusEffect(
  //   React.useCallback(() => {
  //     trackMoengageEvent('Page Visit', {
  //       Page: 'Account',
  //     });
  //   }, []),
  // );
  const listOptions = GlobalScreens.Account.listOptions;

  useEffect(() => {
    fetchClubList();
  }, []);

  const openURL = link => {
    if (link && link !== undefined && link !== 'undefined') {
      Linking.canOpenURL(link).then(supported => {
        if (supported) {
          Linking.openURL(link);
        } else {
          alert('Issues in Opening the URL, try after sometime');
          console.log("Don't know how to open URI: " + link);
        }
      });
    }
  };
  useEffect(() => {
    if (clubList?.length !== 0) {
      setNoClubs(false);
    } else {
      setNoClubs(true);
    }
  }, [clubList]);

  const fetchClubList = async () => {
    await getClubList();
  };

  useFocusEffect(
    React.useCallback(() => {
      if (profileData?.is_chatbot_enabled && Platform.OS === 'web') {
        loadScript(profileData);
        return () => {
          removeScript();
        };
      }
    }, [profileData?.is_chatbot_enabled]),
  );

  // const history = useHistory();
  const userInfo1 = {
    img1: profileData?.avatar || avatar(),
    title: profileData?.displayname,
    subtitle: profileData?.email,
    level: profileData?.level,
    level_icon: profileData?.level_icon,
  };
  const discordLink = globalConfigData?.contestConfig?.discordLink
    ? globalConfigData?.contestConfig?.discordLink
    : 'https://discord.com/invite/5PjgUuVQ';
  const termsAndCondition = globalConfigData?.termsAndCondition;
  const privacyPolicy = globalConfigData?.privacyPolicy;
  const raiseATicket = profileData?.partner?.links?.raiseATicket;
  const faqs = profileData?.partner?.links?.faqs;

  const showToast = amount => {
    toast({
      title: `${amount} credits required for creating an event`,
      variant: 'info'
    });
  };
  const onOptionClick = param => {
    if (param === 'profile') {
      navigation.navigate('Profile');
    } else if (param === 'manageKycBank') {
      navigation.navigate('manageKycBank');
    } else if (param === 'logout') {
      setShowLogOut(true);
    } else if (param === 'discord') {
      if (discordLink) {
        openURL(discordLink);
      }
    } else if (param === 'refer') {
      navigation.navigate('Refer');
    } else if (param === 'rewards') {
      navigation.navigate('Rewards');
    } else if (param === 'LanguageSelection') {
      navigation.navigate(param);
    } else if (param === 'priceView') {
      navigation.navigate('PriceSelection');
    } else if (param === 'TC') {
      if (termsAndCondition) {
        openURL(termsAndCondition);
      }
    } else if (param === 'PRP') {
      if (privacyPolicy) {
        openURL(privacyPolicy);
      }
    } else if (param === 'RT') {
      openURL(raiseATicket);
    } else if (param === 'zendesk') {
      openURL(faqs);
    } else if (param === 'routeRedirect') {
      profileData?.create_event_clickable
        ? navigation.navigate('RewardsStack', {
            screen: 'EventCreate',
          })
        : showToast(profileData?.create_normal_event_defaults?.invest_amount);
    }
    if (param === 'clubsList') {
      navigation.push('ClubStack');
    }
  };

  const onBottomSheetClose = () => {
    setShowLogOut(false);
  };

  const handleLogout = () => {
    onBottomSheetClose();
    logout();
  };

  const signUpClick = () => {
    navigation.navigate(getLoginRoute());
  };

  return (
    <View
      style={{
        // backgroundColor: Color.bgWhite,
        flex: 1,
        paddingTop: insets.top,
        paddingBottom: insets.bottom,
        paddingLeft: insets.left,
        paddingRight: insets.right,
      }}>
      <View style={[globalStyle.headerContainer, globalStyle.headerBlue]}>
        {/* Removing logout button from header */}
      </View>
      {logedIn ? (
        <ImageTextCard
          navigation={navigation}
          item={userInfo1}
          url={profileData?.avatar}
          isHeaderBlock={true}
        />
      ) : (
        <View style={[styles.page_header_absolute_block_account]}>
          <View style={[styles.account_logout_block, styles.text_card_blk]}>
            <View style={{width: '100%'}}>
              <FormTextLabel
                labelStyles={styles.account_logout_block_title}
                label={'Log in/Sign up to unlock trading experience'}
              />
              <Button
                variant="primary"
                onPress={signUpClick}
                style={!globalImport.isWeb ? {flex: 0} : {}}
                translate={true}
              >
                Register
              </Button>
            </View>
          </View>
        </View>
      )}
      <ScrollView
        style={{flexGrow: 1}}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{flexGrow: 1, paddingBottom: 100}}>
        {listOptions?.map((item, i) => {
          if (item.redirect === 'manageKycBank' && profileData?.region !== 'INDIA') {
            return null;
          }
          return (
            <>
              {noClubs && item.title === 'Clubs' ? null : (
                <View key={i}>
                  <TouchableOpacity
                    onPress={() => onOptionClick(item.redirect)}>
                    <AccountRedirectionCard item={item} />
                  </TouchableOpacity>
                </View>
              )}
            </>
          );
        })}
        <Text
          style={{
            ...globalFontStyle.appFontSmallText,
            color: globalConfigurableData.secondaryTextColor1,
            textAlign: 'center',
            marginTop: 30,
          }}>
          App Version : 2.0.01
        </Text>
      </ScrollView>
      <CommonModal
        showModal={showLogOut}
        customModalStyle={[globalStyle.modalView, {alignItems: 'stretch'}]}
        onModalCallBack={onBottomSheetClose}>
        <DeleteModal
          onBottomSheetClose={() => {
            setTimeout(() => {
              onBottomSheetClose();
            }, globalConst?.buttonTimer);
          }}
          onOptionClick={handleLogout}
        />
      </CommonModal>
    </View>
  );
};

const mapStateToProps = ({profile, socialClubReducer}) => ({
  profileData: profile.profileData,
  clubList: socialClubReducer?.clubList,
});
const mapDispatchToProps = {
  getClubList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);

const styles = StyleSheet.create({
  account_logout: {
    alignItems: 'center',
    justifyContent: 'center',
    color: GlobalScreens.Wallet.highlightColor,
  },
  account_logout_text: {
    ...globalFontStyle.appFontSubHeading,
    color: globalConfigurableData.primaryTextColor1,
    paddingRight: 16,
  },

  account_logout_block: {
    height: 130,
    padding: 12,
  },

  account_logout_block_title: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
    marginBottom: 16,
  },
  page_header_absolute_block_account: {
    backgroundColor: globalConfigurableData.globalThemeColor,
    alignItems: 'center',
    height: 130,
    borderBottomColor: globalConfigurableData.borderColor,
    borderBottomWidth: 0.2,
  },
  text_card_blk: {
    backgroundColor: globalConfigurableData.globalThemeColor,
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    shadowOffset: {width: 0, height: 1.657},
    shadowOpacity: 1.657,
    shadowRadius: 3,
    borderRadius: 3,
    alignItems: 'center',
    height: 84.93,
    paddingLeft: 18,
    marginTop: 12,
    width: '100%',
    justifyContent: 'space-between',
  },
  backBtnStyle: {
    width: 30,
    height: 30,
  },
});
